import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import { removeRouterInterface } from './actions'
import useReactRouter from 'use-react-router'
import useListAction from 'core/hooks/useListAction'
import { listAllAvailablePorts } from '../actions'

const DeleteRouterInterfaceDialog = (props) => {
  const { match } = useReactRouter()
  const { id: routerId } = match.params
  const { reload } = useListAction(listAllAvailablePorts)

  const handleClose = () => {
    reload(true, true) // force reload and reset pagination if needed
    props.onClose?.()
  }

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={removeRouterInterface}
      title="Delete Router Interface"
      subTitle="You are about to remove the selected router interface(s) from the router."
      resourceLabel="router interface"
      buildBodyFn={(portInterface) => ({
        subnet_id: portInterface?.fixed_ips?.[0]?.subnet_id,
      })}
      parentId={routerId} // pass routerId once for all rows
      getRowId={(row) => row?.fixed_ips?.[0]?.subnet_id} // custom id for UI
      getRowName={(row) => row?.subnetLabel || row?.name} // custom name for UI
      onClose={handleClose}
    />
  )
}

export default DeleteRouterInterfaceDialog
